module.exports = __webpack_public_path__ + "img/031.af8684c5.png";